import { useQuery } from '@apollo/client';
import { FavoritesQuery } from '@wwtr/generated';
import FAVORITES_QUERY from '@wwtr/gql/queries/favorites.gql';
import { getNetworkStatusDetails } from '@wwtr/libs/apollo';
import { useRouter } from 'next/router';
import { FavoritesListingContainer } from './FavoritesListingContainer';
import { FAVORITE_TYPE, useFavorites } from '@wwtr/libs/contexts';

export const FavoritesApollo = () => {
  const router = useRouter();
  const { favorites } = useFavorites();

  const { data, networkStatus } = useQuery<FavoritesQuery>(FAVORITES_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      organizationLocationIds:
        favorites[FAVORITE_TYPE.ORGANIZATION_LOCATION] ?? [],
      facilityLocationIds: favorites[FAVORITE_TYPE.FACILITY_LOCATION] ?? [],
      organizationIds: favorites[FAVORITE_TYPE.ORGANIZATION] ?? [],
      facilityIds: favorites[FAVORITE_TYPE.FACILITY] ?? [],
      themeIds: favorites[FAVORITE_TYPE.THEME] ?? [],
    },
    skip: !router.isReady,
  });

  const { isLoading } = getNetworkStatusDetails(networkStatus);

  return <FavoritesListingContainer data={data} isLoading={isLoading} />;
};
